<template>
  <v-container>
    <module-bar :title="`(${employeesEnabled.length}) ${employeesEnabled.length == 1 ? `EMPLEADO ACTIVO` : `EMPLEADOS ACTIVOS`
      }`" icon="mdi-file-chart" />

    <v-row v-if="loadingData">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="1" size="60" />
      </v-col>
    </v-row>

    <v-row v-if="loadedData">
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar empleado" single-line hide-details
          style="max-width: 400px" class="mb-5"></v-text-field>

        <v-card outlined>
          <v-data-table :search="search" :headers="headers" :items="employeesEnabled" :items-per-page="10"
            :mobile-breakpoint="800" @click:row="vinculeEmployee">
            <template v-slot:[`item.names`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon :color="item.enabled ? 'green' : 'red'" size="16" v-bind="attrs" v-on="on">
                    mdi-circle
                  </v-icon>
                  {{ item.names }}
                </template>
                <span>{{ item.enabled ? "Activo" : "Inactivo" }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";

export default {
  props: ["vehicule", "tool"],

  components: {
    ModuleBar,
  },

  beforeMount() {
    this.loadingData = true;
    this.loadedData = false;
    setTimeout(() => {
      this.$store.dispatch("findEmployeesAction").then((res) => {
        this.employees = res;
        this.loadingData = false;
        this.loadedData = true;
      });
    }, 500);
  },

  data() {
    return {
      employee: null,
      loadingData: true,
      loadedData: false,
      dialog: false,
      search: "",
      click: 0,
      headers: [
        {
          text: "Nombre",
          value: "names",
          width: "30%",
        },
        {
          text: "Apodo",
          aling: "center",
          value: "avatar",
          width: "20%",
        },
        {
          text: "Procedencia",
          aling: "center",
          value: "last_names",
          width: "20%",
        },
        {
          text: "Ubicacion",
          value: "location.name",
          width: "20%",
        },
      ],
      employees: [],
    };
  },

  computed: {
    employeesEnabled() {
      if (this.employees) {
        let employeesEnabled = [];
        this.employees.forEach((element) => {
          if (element.enabled) {
            employeesEnabled.push(element);
          }
        });
        return employeesEnabled;
      } else return null;
    },
  },

  methods: {
    vinculeEmployee(value) {
      this.$confirm({
        message: `Desea vincular el empleado: ${value.names}?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingData = true;
            this.loadedData = false;

            setTimeout(() => {
              let path = this.tool ? `vinculeEmployeeTool` : `vinculeEmployeeVehicule`;

              let payload = {
                params_id: this.tool ? this.tool.id : this.vehicule.id,
                employee_id: value.id,
              }

              this.$store
                .dispatch(path, payload)
                .then(() => {
                  this.loadingData = false;
                  this.loadedData = true;

                  this.tool ?
                    this.$emit("vinculeEmployeeToolEmit", { employee: value }) :
                    this.$emit("vinculeEmployeeVehiculeEmit", { employee: value });
                })
                .catch(() => {
                  this.loadingData = false;
                });
            }, 500);
          }
        },
      });

      this.employee = value;
      this.dialog = true;
      this.click++;
    },
  },
};
</script>
